import { render } from "./ChargeFoodModal.vue?vue&type=template&id=651ffa46"
import script from "./ChargeFoodModal.vue?vue&type=script&lang=js"
export * from "./ChargeFoodModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__